@if (reviewType === 'cards') {
  <card-reviews
    [title]="reviewTitle"
    [backgroundInfo]="backgroundImage ? backgroundImage : backgroundColor"
    [textColorOverride]="textColorOverride"
    [containerClasses]="containerClasses"
    >
  </card-reviews>
}
@if (reviewType === 'slider') {
  <carousel-reviews
    [title]="reviewTitle"
    [backgroundInfo]="backgroundImage ? backgroundImage : backgroundColor"
    [backgroundColorValue]="backgroundColorValue"
    [textColorValue]="textColorValue"
    [textColorOverride]="textColorOverride"
    [containerClasses]="containerClasses"
    >
  </carousel-reviews>
}
@if (reviewType === 'columns') {
  <column-reviews
    [title]="reviewTitle"
    [backgroundInfo]="backgroundImage ? backgroundImage : backgroundColor"
    [backgroundColorValue]="backgroundColorValue"
    [textColorValue]="textColorValue"
    [containerClasses]="containerClasses"
    [textColorOverride]="textColorOverride"
    >
</column-reviews>
}
@if (reviewType === 'columnsType2') {
  <column-type2-reviews
    [title]="reviewTitle"
    [backgroundInfo]="backgroundImage ? backgroundImage : backgroundColor"
    [textColorValue]="textColorValue"
    [textColorOverride]="textColorOverride"
    [containerClasses]="containerClasses"
    >
</column-type2-reviews>
}
@if (reviewType === 'stars') {
  <star-reviews
    [title]="reviewTitle"
    [backgroundInfo]="backgroundImage ? backgroundImage : backgroundColor"
    [textColorOverride]="textColorOverride"
    [containerClasses]="containerClasses"
    >
  </star-reviews>
}
@if (reviewType === 'single') {
  <single-review
    [title]="reviewTitle"
    [backgroundInfo]="backgroundImage ? backgroundImage : backgroundColor"
    [textColorValue]="textColorValue"
    [textColorOverride]="textColorOverride"
    [containerClasses]="containerClasses"
    >
  </single-review>
}
